// 📁 src/data/loadArticles.js

function normalizeBlocks(article) {
  const raw = article.blocks || article.content?.blocks || article.content;

  if (Array.isArray(raw)) {
    return raw.map((block) => {
      if (block?.type === "model") block.type = "model3d"; // Legacy-Kompatibilität
      return block;
    });
  }

  if (typeof raw === "string") {
    return [
      {
        type: "paragraph",
        data: {
          text: raw.replace(/\n/g, "<br>"), // \n → <br> für Zeilenumbrüche
        },
      },
    ];
  }

  return [];
}

function slugify(title = "") {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

function getApiBase() {
  if (typeof window !== "undefined" && window.location.hostname === "localhost") {
    return ""; // nutzt CRA-Proxy -> https://www.denisbitter.de/stage01/api
  }
  return "https://www.denisbitter.de/stage01/api";
}

async function fetchJsonWithTimeout(url, timeoutMs = 12000) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const response = await fetch(url, { signal: controller.signal });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    return await response.json();
  } finally {
    clearTimeout(timeoutId);
  }
}

// 🎯 NEUE SIGNATUR: loadArticles kann jetzt optional einen slug erwarten
export async function loadArticles(slugToLoad = null) {
  try {
    const apiBase = getApiBase();

    // Wenn ein spezifischer Slug angefordert wird, laden wir nur DIESEN Artikel
    if (slugToLoad) {
      const json = await fetchJsonWithTimeout(`${apiBase}/articles.php?slug=${slugToLoad}`);

      // Überprüfe, ob die Antwort leer ist oder nicht das erwartete Format hat
      if (!json || Object.keys(json).length === 0) {
        console.warn(`⚠️ Artikel ${slugToLoad} wurde gefunden, aber die Antwort ist leer oder ungültig.`);
        return null;
      }

      return {
        ...json,
        blocks: normalizeBlocks(json),
        slug: slugify(json.title || "unbenannt"), // Stelle sicher, dass der Slug konsistent ist
      };
    }

    // Wenn kein Slug angefordert wird, laden wir weiterhin ALLE Artikel (für Übersichtsseiten)
    const filenames = await fetchJsonWithTimeout(`${apiBase}/articles.php`);

    const articlePromises = filenames.map(async (file) => {
      try {
        const json = await fetchJsonWithTimeout(`${apiBase}/articles.php?slug=${file}`);

        return {
          ...json,
          blocks: normalizeBlocks(json),
          slug: slugify(json.title || "unbenannt"),
        };
      } catch (err) {
        console.warn(`⚠️ Artikel ${file} konnte nicht geladen werden:`, err);
        return null;
      }
    });

    const all = await Promise.all(articlePromises);
    return all.filter(Boolean);

  } catch (e) {
    console.error("❌ Fehler beim Laden der Artikelliste oder des Artikels:", e);
    return slugToLoad ? null : []; // Fallback für spezifischen Artikel oder Liste
  }
}
